export const FIXED_WIDTH = "w-[330px]";
